import { createFileRoute, redirect } from "@tanstack/react-router";

export const buildLegacyThreadsRedirect = (search: Record<string, unknown>) => {
  const thread = Number(search.thread);
  return {
    to:
      search.view === "favorites"
        ? ("/favorites" as const)
        : ("/following" as const),
    search: Number.isSafeInteger(thread) && thread > 0 ? { thread } : {},
  };
};

export const buildLegacyThreadsRedirectOptions = (
  search: Record<string, unknown>,
) => ({
  ...buildLegacyThreadsRedirect(search),
  replace: true,
});

export const Route = createFileRoute("/threads")({
  beforeLoad: ({ search }) => {
    throw redirect(
      buildLegacyThreadsRedirectOptions(search as Record<string, unknown>),
    );
  },
});
